import React from 'react'

const DashBoardSetting = () => {
    return (
        <div>DashBoardSetting</div>
    )
}

export default DashBoardSetting